import React, { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useBoolean } from "@fluentui/react-hooks";
import styles from "../POIList/POIList.module.css";
import {
    ActionButton,
    DetailsList,
    IColumn, IconButton,
    IDropdownOption,
    IDropdownStyles,
    IIconProps,
    TooltipOverflowMode,
    IStackStyles,
    MessageBarType,
    SelectionMode,
    Stack,
    StackItem
} from "@fluentui/react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { ContactItem } from "../../../model/ManagePOIListItem";
import { fetchCP } from "../../../services/ManageSystemServices/ContactPersonService";
import AddEditDialog from "../Dialogs/AddEditContact";
import DeleteDialog from "../Dialogs/DeleteContactDialog";
import QuickSearch from '../../Admin/QuickSearch/QuickSearch';
import Pagination from "../../Pagination/Pagination";
import { LS_USER_INFO, PERSON_CONTACT_TYPE, TEAM_CONTACT_TYPE } from "../../../constants/EiopaFnPConstants";
import EiopaFnPIcons from "../../EiopaFnPIcons/EiopaFnPIcons";
import strings from "../../../loc/strings";
import { displayMessageBar } from "../../LayoutWithAuth/LayoutWithAuth";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { Delete20Filled, FluentIconsProps } from "@fluentui/react-icons";

initializeIcons();

const betweenStackStyles: IStackStyles = {
    root: {
        justifyContent: "space-between",
    }
}

interface IPagination {
    // isMetricsCalloutVisible: boolean;
    columnsState: IColumn[];
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
}
const customDropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 400 }

};

const customTextFieldStyles = {
    fieldGroup: {
        width: 400
    },
};

function CAContactList(props: any) {

    const auth = useAuth();

    let userInfo = { username: "", ncaCode: "", roles: [] };
    const userInfoLS: string = localStorage.getItem(LS_USER_INFO) as string;
    if (userInfoLS !== null) {
        userInfo = JSON.parse(userInfoLS);
    }

    const initialContact = {
        "id": undefined,
        "contactTypeId": PERSON_CONTACT_TYPE,
        "country": null,
        "authority": userInfo.ncaCode,
        "position": null,
        "teamName": null,
        "firstName": null,
        "lastName": null,
        "email": null,
        "professionalPhoneNumber": null,
        "createdDate": new Date().toISOString(),
        "createdBy": auth.user?.profile.email,
    };

    const [isSortedDescendings, { toggle: toggleIsSortedDescendings }] = useBoolean(true);

    const iconStyleProps: FluentIconsProps = {
        primaryFill: "#0078D4",
        className: styles.filterIcon,
    };

    function onRenderPrefix() {
        return <Delete20Filled aria-label={"Filter"} {...iconStyleProps} />;
    }

    function _onRenderActionsMenuIcon() {
        return <></>;
    }

    // Render Column Action
    const _ContactColumns: IColumn[] = [
        {
            key: "name",
            name: "Type",
            fieldName: "name",
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            isSorted: true,
            isSortedDescending: isSortedDescendings,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A',
            onColumnClick: _onColumnClick,
        },
        {
            key: "firstName",
            name: "First name",
            fieldName: "firstName",
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
        },
        {
            key: "lastName",
            name: "Last name",
            fieldName: "lastName",
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
        },
        {
            key: "position",
            name: "Position",
            fieldName: "position",
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
        },
        {
            key: "teamName",
            name: "Team name",
            fieldName: "teamName",
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
        },
        {
            key: "email",
            name: "Email",
            fieldName: "email",
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
        },
        {
            key: "professionalPhoneNumber",
            name: "Professional tel no.",
            fieldName: "professionalPhoneNumber",
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onRenderHeader: () => (
                <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={'Professional tel no.'}>{'Professional tel no.'}</TooltipHost>
            ),
        },
        {
            key: "legalFrameworkDepartment",
            name: "Legal framework - department",
            fieldName: "legalFrameworkDepartment",
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
        },
        {
            key: "action",
            name: "Actions",
            fieldName: "action",
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onRender: (item: any) => {
                return (
                    <>
                        <IconButton
                            onRenderIcon={_onRenderActionsIcon}
                            onRenderMenuIcon={_onRenderActionsMenuIcon}
                            title="Settings"
                            menuProps={{
                                items: [
                                    {
                                        key: 'edit',
                                        text: 'Edit',
                                        iconProps: { iconName: 'EditSolid12' },
                                        onClick: () => {
                                            setEditItem({ ...item });
                                            setValueDropdown("Edit");
                                            handleOpenDialog(item?.contactTypeId);
                                        },
                                    },
                                    {
                                        key: 'delete',
                                        text: 'Delete',
                                        onRenderIcon: onRenderPrefix,
                                        onClick: () => { setEditItem({ ...item }); handleOpenDialogDelete(); },
                                    },
                                ],
                            }}
                        />
                    </>
                );
            },
        },
    ];

    const [dialogIsHidden, setDialogIsHidden] = React.useState(true);
    const [dialogIsHiddenDelete, setDialogIsHiddenDelete] = React.useState(true);
    const [items, setItems] = React.useState<ContactItem[]>([]);
    const [filteredItems, setFilteredItems] = React.useState<ContactItem[]>([]);
    const [itemsOrg, setItemsOrg] = React.useState<ContactItem[]>([]);
    const [itemsCP, setItemsCP] = React.useState<ContactItem[]>([]);
    const [editItem, setEditItem] = React.useState<ContactItem>(Object);
    const [orig] = React.useState<ContactItem>(Object);
    const [valueDropdown, setValueDropdown] = React.useState("Edit");
    const [selectedContactTypeInDialog, setSelectedContactTypeInDialog] = useState(PERSON_CONTACT_TYPE);
    const [state, setState] = React.useState<IPagination>({
        columnsState: _ContactColumns,
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0
    });
    const [totalItems, setTotalItems] = React.useState<number>();

    // Icons
    const add: IIconProps = { iconName: 'Add' };

    const handleOpenDialogDelete = () => {
        setDialogIsHiddenDelete(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            await fetchContactItems();
        };
        fetchData();
    }, []);

    useEffect(() => {
        const startIndex = (state.currentPage - 1) * state.itemsPerPage;
        const endIndex = Math.min(startIndex + state.itemsPerPage, itemsCP.length);
        const itemsOnCurrentPage = itemsOrg.slice(startIndex, endIndex);

        setItems(itemsOnCurrentPage);
    }, [itemsOrg]);

    // Effect to handle itemsPerPage change and update displayed items pagination
    useEffect(() => {

        const startIndex = (state.currentPage - 1) * state.itemsPerPage;
        const endIndex = Math.min(startIndex + state.itemsPerPage, itemsCP.length);
        const itemsOnCurrentPage = filteredItems?.length > 0 ? filteredItems.slice(startIndex, endIndex) : itemsOrg.slice(startIndex, endIndex);
        setItems(itemsOnCurrentPage);
    }, [state.currentPage, state.itemsPerPage, itemsCP]);

    // Function to handle processed data from QuickSearch component
    const handleItemsProcessed = (processedData: any) => {
        setTotalItems(processedData.length);
        setFilteredItems(processedData);
        if (processedData.length > 0) {
            setItems(processedData);
            const startIndex = 0;
            const endIndex = Math.min(startIndex + state.itemsPerPage, processedData.length);
            const itemsOnCurrentPage = processedData.slice(startIndex, endIndex);

            setItems(itemsOnCurrentPage);
            setState({
                ...state,
                currentPage: 1
            });
        } else {
            setItems([]);
        }
    };

    function _onRenderActionsIcon() {
        return <EiopaFnPIcons iconName={"actions"} iconColor={"#0078D4"} />;
    }

    const handleOpenDialog = (contactType: number) => {
        setSelectedContactTypeInDialog(contactType);
        setDialogIsHidden(false);
    };

    // Function to handle page change pagination
    function _onPageChange(selectedItem: number) {
        setState({
            ...state,
            currentPage: selectedItem
        });
    }

    // Function to handle itemsPerPage change pagination
    function _onChangeItemsPerPage(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) {
        setState({
            ...state,
            itemsPerPage: item.key as number,
            currentPage: 1
        });
    }

    //pagination
    const totalItemsToPass = totalItems !== undefined ? totalItems : 0;

    async function fetchContactItems() {
        try {
            const _items = await fetchCP(auth.user?.id_token);

            const combined = _items.map(item => ({
                ...item,
                name: item.contactType?.name
            }));

            setItemsCP(combined);
            setTotalItems(combined.length);
            setItemsOrg(combined);
        } catch (error) {
            console.error("Error fetching contact items", error);
            setItemsCP([]);
            setTotalItems(0);
            setItemsOrg([]);
        }
    }

    const resetField = async () => {
        setEditItem(orig);
        await fetchContactItems();
    }

    const handleActionResponse = (response: string, eiopaErrorMessage?: string) => {
        resetField();

        switch (response) {
            case "cpcreatetrue":
                displayMessageBar(MessageBarType.success, strings.addNewContactSuccessMessage, false);
                break;
            case "cpcreatefalse":
                displayMessageBar(MessageBarType.error, strings.addNewContactErrorMessage, false);
                break;
            case "cpcreateexist":
                displayMessageBar(MessageBarType.error, strings.addNewContactExistsMessage, false);
                break;
            case "cpedittrue":
                displayMessageBar(MessageBarType.success, strings.updateNewContactSuccessMessage, false);
                break;
            case "cpeditfalse":
                displayMessageBar(MessageBarType.error, strings.updateNewContactErrorMessage, false);
                break;
            case "cpeditexist":
                displayMessageBar(MessageBarType.error, strings.updateNewContactExistMessage, false);
                break;
            case "cpdeletefalse":
                displayMessageBar(MessageBarType.error, strings.deleteNewContactErrorMessage, false);
                break;
            case "cpdeletetrue":
                displayMessageBar(MessageBarType.success, strings.deleteNewContactSuccessMessage, false);
                break;
            case "error":
                // Display the specific error message from the API
                displayMessageBar(MessageBarType.error, eiopaErrorMessage ?? strings.assessmentDefaultErrorMessage, false);
                break;
            default:
                displayMessageBar(MessageBarType.error, eiopaErrorMessage ?? strings.assessmentDefaultErrorMessage, false);
                break;
        }
    }

    function _onColumnClick(event: React.MouseEvent<HTMLElement>, column: IColumn) {
        toggleIsSortedDescendings();
        let isSortedDescending = column.isSortedDescending;

        if (column.isSorted) {
            isSortedDescending = !isSortedDescending;
        }

        const newItems = itemsOrg.sort(fieldSorter(['-' + column.fieldName, 'teamName', 'lastName'], !isSortedDescendings));

        const startIndex = (state.currentPage - 1) * state.itemsPerPage;
        const endIndex = Math.min(startIndex + state.itemsPerPage, newItems.length);
        const itemsOnCurrentPage = newItems.slice(startIndex, endIndex);

        setItems(itemsOnCurrentPage);
    }

    function fieldSorter(fields: any, isSortedDescending?: boolean) {
        return function (a: any, b: any) {
            return fields
                .map(function (o: any) {
                    let dir = 1;
                    if (o[0] === '-') {
                        dir = -1;
                        o = o.substring(1);
                    }
                    if (isSortedDescending || (o === "teamName" || o === "lastName")) {
                        if (a[o]?.toLowerCase() > b[o]?.toLowerCase()) return dir;
                        if (a[o]?.toLowerCase() < b[o]?.toLowerCase()) return -(dir);
                    }
                    else {
                        if (a[o]?.toLowerCase() < b[o]?.toLowerCase()) return dir;
                        if (a[o]?.toLowerCase() > b[o]?.toLowerCase()) return -(dir);
                    }
                    return 0;
                })
                .reduce(function firstNonZeroValue(p: any, n: any) {
                    return p ? p : n;
                }, 0);
        };
    }

    const options: IDropdownOption[] = [
        { key: 'name', text: 'Type' },
        { key: 'firstName', text: 'First Name' },
        { key: 'lastName', text: 'Last Name' },
        { key: 'teamName', text: 'Team Name' },
        { key: 'email', text: 'Email' },
        { key: 'professionalPhoneNumber', text: 'Professional tel no.' },
        { key: 'legalFrameworkDepartment', text: 'Legal framework - department' },
    ];

    let SelectDialog: any;
    switch (valueDropdown) {
        case "Add":
            SelectDialog = <AddEditDialog
                item={initialContact}
                items={items}
                setItems={setItems}
                dialogIsHidden={dialogIsHidden}
                setDialogIsHidden={setDialogIsHidden}
                title="Add contact"
                handleActionResponse={handleActionResponse}
                isAdd={true}
                selectedContactTypeInDialog={selectedContactTypeInDialog}
                setSelectedContactTypeInDialog={setSelectedContactTypeInDialog}
            />;
            break;
        default:
            SelectDialog = <AddEditDialog
                item={editItem}
                items={items}
                setItems={setItems}
                dialogIsHidden={dialogIsHidden}
                setDialogIsHidden={setDialogIsHidden}
                title="Edit contact"
                isAdd={false}
                handleActionResponse={handleActionResponse}
                selectedContactTypeInDialog={selectedContactTypeInDialog}
                setSelectedContactTypeInDialog={setSelectedContactTypeInDialog}
            />;
            break;
    }

    function _renderItemColumn(item?: any, index?: number, column?: IColumn) {
        if (item && column) {
            const fieldContent = item[column.fieldName as keyof any] as string;
            return <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={fieldContent}>{fieldContent}</TooltipHost>
        }
    }

    const addTooltipToColumnHeader = (cols: IColumn[]) => {
        const a = cols.map((column) => ({
            ...column,
            onRenderHeader: () => (
                <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={column.name}>{column.name}</TooltipHost>
            ),
        }))
        return cols;
    }

    return (
        <Stack>
            <StackItem className={styles.PoiListHeader}>
                {"CA contact list"}
            </StackItem>
            <Stack horizontal className={styles.FilterByAssessment} styles={betweenStackStyles}>
                <QuickSearch options={options} items={items} itemsOrg={itemsOrg} onItemsProcessed={handleItemsProcessed} columns={state.columnsState} textFieldStyles={customTextFieldStyles} dropdownStyles={customDropdownStyles}
                />
                <ActionButton iconProps={add} onClick={() => { setEditItem(orig); setValueDropdown("Add"); handleOpenDialog(PERSON_CONTACT_TYPE); }} className={styles.FilterButton} >
                    Add contact
                </ActionButton>
            </Stack>
            <StackItem>
                <DetailsList layoutMode={1}
                    columns={addTooltipToColumnHeader(_ContactColumns)}
                    items={items}
                    selectionMode={SelectionMode.none}
                    onRenderItemColumn={_renderItemColumn}
                />
            </StackItem>
            <DeleteDialog
                id={editItem.id}
                encryptedId={editItem.encryptedId}
                dialogIsHiddenDelete={dialogIsHiddenDelete}
                setDialogIsHiddenDelete={setDialogIsHiddenDelete}
                title="Delete contact"
                handleActionResponse={handleActionResponse}
            />
            <StackItem>
                <Pagination
                    currentPage={state.currentPage}
                    onPageChange={_onPageChange}
                    itemsPerPage={state.itemsPerPage}
                    onChangeItemsPerPage={_onChangeItemsPerPage}
                    totalItems={totalItemsToPass}
                />
            </StackItem>
            {SelectDialog}
        </Stack>
    );
}

export default CAContactList;
